import { render, staticRenderFns } from "./TrendData.vue?vue&type=template&id=745dcc87"
import script from "./TrendData.vue?vue&type=script&lang=js"
export * from "./TrendData.vue?vue&type=script&lang=js"
import style0 from "./TrendData.vue?vue&type=style&index=0&id=745dcc87&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports